<template>
  <v-combobox
      :filled="!!filled"
      :items="$autocompletion.get('keywords')"
      :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-text-search' : ''"
      :search-input.sync="currentValue"
      :menu-props="{ auto: true, overflowY: true, disableKeys: true }"
      :label="label || $t('label')"
      :hint="hint || $t('hint')"
      hide-no-data
      :rules="rules"
      :hide-details="!!hideDetails"
      @keyup.enter.prevent="$emit('enter')"
  >
    <template v-slot:append>
      <v-chip label outlined color="blue darken-2" v-if="isValid && isNew" small>{{ $t('new') }}</v-chip>
    </template>
    <template v-slot:item="{ index, item }">
      <v-btn small icon @click.stop="$autocompletion.remove('keywords', item)" class="mr-2">
        <v-icon small>mdi-delete</v-icon>
      </v-btn>
      {{ item }}
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: 'KeywordSelect',
  props: ['value', 'label', 'hint', 'filled', 'hideDetails', 'showNew'],
  data () {
    return {
      currentValue: this.value,
      rules: [
        () => this.isValid || this.$t('required'),
      ]
    }
  },
  watch: {
    currentValue () {
      this.sanitize()
      this.$emit('update:value', this.currentValue)
    },
    value (value) {
      this.currentValue = value
    }
  },
  computed: {
    isValid () {
      if (this.currentValue) {
        return !!this.currentValue
      } else {
        return false
      }
    },
    isNew () {
      if (this.showNew) {
        if (this.currentValue) {
          return !this.$autocompletion.get('keywords').includes(this.currentValue)
        }
      }

      return false
    }
  },
  methods: {
    sanitize () {
      if (this.currentValue) {
        this.currentValue = this.$models.Input.sanitizeKeywordName(this.currentValue)
      }
    }
  }
}
</script>

<i18n>
{
	"en": {
		"hint": "Enter or select the keyword to search for.",
		"label": "Keyword",
		"new": "New",
		"required": "A valid keyword is required."
	},
	"es": {
		"hint": "Ingrese o seleccione la palabra clave a buscar.",
		"label": "Palabra clave",
		"new": "Nuevo",
		"required": "Se requiere una palabra clave válida."
	},
	"fr": {
		"hint": "Saisissez ou sélectionnez le mot clé à rechercher.",
		"label": "Mot clé",
		"new": "Nouveau",
		"required": "Un mot clé valide est requis."
	},
	"it": {
		"hint": "Inserisci o seleziona la parola chiave da cercare.",
		"label": "Parola chiave",
		"new": "Nuovo",
		"required": "È richiesta una parola chiave valida."
	},
	"pt": {
		"hint": "Introduza ou selecione a palavra-chave a pesquisar.",
		"label": "Palavra-chave",
		"new": "Novo",
		"required": "É necessária uma palavra-chave válida."
	},
	"pl": {
		"hint": "Wpisz lub wybierz słowo kluczowe do wyszukania.",
		"label": "Słowo kluczowe",
		"new": "Nowe",
		"required": "Wymagane jest prawidłowe słowo kluczowe."
	}
}
</i18n>